import { LoggerService } from '@wdpr/ra-angular-logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@wdpr/ra-angular-logger";
export class ScriptLoaderService {
    constructor(document, logger) {
        this.document = document;
        this.logger = logger;
        this.scripts = {};
    }
    loadScript(src) {
        return new Promise((resolve, reject) => {
            if (!src) {
                this.logger.error(`Must provide script source!`);
                return resolve(false);
            }
            if (this.scripts[src]) {
                this.logger.log(`Script ${src} already loaded.`);
                return resolve(false);
            }
            this.scripts[src] = false;
            const htmlHeadElement = this.document.head;
            const script = this.createScriptElement(src);
            script.onerror = (err) => {
                this.logger.error(`Script error: ${err}`);
                return resolve(false);
            };
            script.onload = () => {
                this.logger.debug(`Script ${src} loaded.`);
                this.scripts[src] = true;
                return resolve(true);
            };
            htmlHeadElement.appendChild(script);
        });
    }
    createScriptElement(src) {
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        script.defer = true;
        return script;
    }
}
ScriptLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScriptLoaderService_Factory() { return new ScriptLoaderService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.LoggerService)); }, token: ScriptLoaderService, providedIn: "root" });
